<template>
	<div class="mb_db learner_program_data">
		<div class="row">
      <div class="col-12">
        <template v-if="isStreamStructureRendered">
	        <template v-if="selectedProgram.uuid">
	        	<div class="row">
							<div class="col-12 sub_hd_bar" style="margin-top: 10px; margin-bottom: 0px;">
								<template v-if="selectedProgram.programThumbnail">
									<div class="sub_hd_ic">
										<img :src="selectedProgram.programThumbnail">
									</div>
								</template>
								<template v-else>
									<div class="sub_hd_ic">
										<div class="ic ic-icon_program"></div>
									</div>
								</template>
								<div class="hd_txt">
									<template v-if="learnerEnrollmentData.length > 1">
										<v-select :options="learnerEnrollmentData" :clearable="false" label="programTitle" v-model="selectedProgram" @input="renderSelectedProgram">
										  <template slot="option" slot-scope="option">
										    <img :src="option.programThumbnail" style="width: 20px; height: 20px" />
										    {{option.programTitle}}
										  </template>
										</v-select>
									</template>
									<template v-else>
										{{selectedProgram.programTitle}}
									</template>
								</div>
							</div>
						</div>
	          <template v-if="course.uuid">
		          <div class="text-center prog-lmi">
								<div class="row crd_content">
									<div class="col-12">
			              <div class="row sec_row">
			                <div class="col-3 thumbnail_container">
			                	<div class="thumbnail" :style="{background: setThumbnailBgColor(course.uuid)}">
		                      <div class="txt" style="color: #fff;">
		                        <div v-html="setThumbnailTitle(course.title)"></div>
		                      </div>
		                    </div>
			                </div>
			                <div class="col-9 entity_title">
												{{course.title}}
											</div>
			              </div>
			            </div>
								</div>

								<div class="lnk_container" v-if="!userObj.suspended && transactionValidity.transactionValid && releaseStatus">
                  <b-btn @click="continueLearning" :aria-label="buttonLabel" size="sm">{{buttonLabel}}</b-btn>
								</div>

								<div class="lnk_container" v-if="!releaseStatus">
                  <b-link class="btn_lock_unlock" v-b-modal="'releaseModal_' + course.uuid">
										<span class="ic22-lock"></span>
									</b-link>
      					</div>
								<div class="modal_popup_container custom_modal_v4 course_unlock_modal">
                  <b-modal class="description_modal" :id="'releaseModal_' + course.uuid" :title="$t('courseLocked')" ok-only :ok-title="$t('ok')">
										<div class="ic_container" style="top: 3px;">
											<span class="ic ic22-lock"></span>
										</div>
										<div class="row">
											<div class="col-12 txt_row">
												{{course.title}}
											</div>
                      <div class="col-12 txt_row">
                        <div v-html="releaseLogicDetail"></div>
                      </div>
                    </div>
                  </b-modal>
								</div>
								<div class="row alert_msg_sec" v-if="!transactionValidity.transactionValid">
									<div class="col-12 msg_container" v-html="transactionValidity.institutionPurchaseExpirationMessage"></div>
									<div class="col-12 btn_container">
										<b-btn class="btn btn-secondary" @click="navigateToSelectedProgram">{{ $t('renew') }}</b-btn>
									</div>
								</div>
								<div class="row alert_msg_sec" v-if="transactionValidity.transactionValid && userObj.suspended">

									<div class="col-12 msg_container">
												<span v-html="institution.userSuspensionMessage">
												</span>
									</div>
								</div>

		          </div>
	          </template>
	          <template v-else>
		          <div class="text-center prog-lmi">
								<div class="crd_content">
			            <div class="row crd_content">
			              <div class="col-12 sec_msg">
				               <span v-if="isCourseCompleted">{{ $t('congratulationsCourseCompleted') }}</span>
											 <span class="no_info" v-else>{{ $t('learningDataNotAvailable') }}</span>
				            </div>
			            </div>
								</div>
		          </div>
		        </template>
	        </template>
	        <template v-else>
	          <div class="text-center prog-lmi">
							<div class="row">
								<div class="col-12 sub_hd_bar">
									<div class="sub_hd_ic">
										<div class="ic ic-icon_program"></div>
									</div>
									<div class="hd_txt">
										{{ $t('myProgramLearning') }}
									</div>
								</div>
							</div>
							<div class="row crd_content">
		            <div class="col-12">
		              <div class="row sec_row">
	              		<div class="no_data">
											{{ $t('programLearningDataNotAvailable') }}
										</div>
	              	</div>
	              </div>
							</div>
	          </div>
	        </template>
        </template>
        <template v-else>
	      	<div class="crd_content">
	      		<div class="mt-4 text-center">
            	<stretch></stretch>
            </div>
					</div>
	      </template>
      </div>
    </div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	//import {Stretch} from 'vue-loading-spinner'

	export default {
		name: 'learner-program-course-learn',
		props: ['program'],
		components: {
		    //Stretch
		},
    data: () => {
    	return {
    		course: {},
    		releaseStatus :true,
    		releaseLogicDetail: '',
    		buttonLabel: '',
    		planningStream: {},
    		selectedProgram: {},
    		competencySummaries: [],
    		isCourseCompleted: false,
    		isStreamStructureRendered: false,
        transactionValidity: {}
    	}
    },
    beforeMount () {
    	this.competencySummaries = []
    	_.forEach(this.learnerEnrollmentData, (data) => {
    		let programCode = data.programCode
    		this.populateStreamStructure(programCode)
    	})
    },
    mounted () {
    	this.$nextTick(() => {
    		this.$nextTick(() => {
	    		setTimeout(() => {
		    		this.renderCurrentProgramAndCourse()
		    	}, 3000)
	    	})
    	})
    },
		methods: {
			...mapActions([
        'loadStreamWithStructure',
        'loadCompetencyProgress',
        'loadContinueLearningLast',
        'loadCheckTransactionValidity',
        'loadStreamWithStructureSummary',
        'loadStreamLeafForCourse'
      ]),
      navigateToSelectedProgram () {
        let routerParams = {
          cipCode: this.selectedProgram.programCipCode,
          programGuideCode: this.selectedProgram.programCode,
          type: this.selectedProgram.programType,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      renderSelectedProgram (selectedProgram) {
      	let programCode = selectedProgram.programCode
      	this.renderCurrentProgramAndCourse(programCode)
      },
      populateCurrentCompetencySummary (competencySummaries, isNoActivity) {
      	let competencySummary = undefined
      	let sortedSummaries = _.orderBy(competencySummaries, ['status', 'lastUpdatedTime'], ['desc', 'desc'])
      	let filteredSummaries = _.filter(sortedSummaries, (summary) => {
    			return (summary.status !== 2)
    		})
    		if (filteredSummaries.length > 0) {
    			let index = isNoActivity ? (filteredSummaries.length - 1) : 0
    			competencySummary = filteredSummaries[index]
    		} else {
    			let index = isNoActivity ? (sortedSummaries.length - 1) : 0
      		competencySummary = sortedSummaries[index]
    		}
    		return competencySummary
      },
      async renderCurrentProgramAndCourse (programCode) {
      	this.course = {}
      	this.releaseStatus = true
      	this.releaseLogicDetail = ''
      	this.selectedProgram = {}
        this.transactionValidity = {}
      	this.isCourseCompleted = false
      	this.isStreamStructureRendered = false
      	let competencySummary = undefined
      	let isNoActivity = true
      	for (let i = 0; i < this.competencySummaries.length; i++) {
      		let summary = this.competencySummaries[i]
      		if (summary.status > 0) {
      			isNoActivity = false
      			break
      		}
      	}
      	if (programCode) {
      		let summaries = _.filter(this.competencySummaries, (summary) => {
      			return (programCode === summary.uuid.split('_')[0])
      		})
      		competencySummary = this.populateCurrentCompetencySummary(summaries, isNoActivity)
      	} else {
      		competencySummary = this.populateCurrentCompetencySummary(this.competencySummaries, isNoActivity)
      	}
      	this.isCourseCompleted = (competencySummary.status === 2)
				if (!this.isCourseCompleted) {
					this.course = {uuid: competencySummary.courseId, title: competencySummary.titleForStudent}
					this.buttonLabel = (competencySummary.status === 0) ? this.$t('startLearning') : this.$t('continueLearning')
				} else {
					this.buttonLabel = this.$t('viewCourse')
				}
        this.isStreamStructureRendered = true
        let key = competencySummary.uuid.split('_')[0]
        let selectedProgram = _.find(this.learnerEnrollmentData, (data) => {
          return (key === data.programCode)
        })

				let currentProgramCode = selectedProgram?selectedProgram.programCode:programCode
				if(currentProgramCode) {
						let courseLeaf = await this.loadStreamLeafForCourse({programCode:selectedProgram.programCode, originUuid:competencySummary.courseId})
		        this.releaseStatus = courseLeaf.releaseStatus
		        this.releaseLogicDetail = courseLeaf.releaseLogicDetail
		     }

        this.$root.$emit('reloadCompetencyProgress', selectedProgram)
        this.selectedProgram = selectedProgram
        this.transactionValidity = await this.loadCheckTransactionValidity(this.selectedProgram.programCode)
      },
      async populateStreamStructure (programCode) {
        let summaries = await this.loadStreamWithStructureSummary(programCode)
      	for (let i = 0; i < summaries.length; i++) {
      	    let competencySummary =  summaries[i]
      			competencySummary.uuid = programCode + '_' + competencySummary.uuid
      			this.competencySummaries.push(competencySummary)
      	}

/*        this.planningStream = await this.loadStreamWithStructure(programCode)
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let children = JSON.parse(childStructure)
              let courses = _.filter(children, (child) => {
			          return (child.entityType === 'deliverycontext')
			        })
			        let sortedCourses = _.sortBy(courses, 'order')
			        for (let i = 0; i < sortedCourses.length; i++) {
			        	let course = sortedCourses[i]
			        	let courseId = course.originUuid
			        	let competencySummary = await this.loadCompetencyProgress(courseId)
			        	competencySummary.uuid = programCode + '_' + competencySummary.uuid
			        	this.competencySummaries.push(competencySummary)
			        }
            }
          }
        }
*/
      },
			continueLearning () {
				this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        let courseId = this.course.uuid
        this.loadContinueLearningLast(courseId).then(options => {
        	if (options && options.length > 0) {
        		if (options[0].title === 'EXTRENAL_COURSE_LAUNCH') {
              let _window = window.open(options[0].uri, '_blank')
               setTimeout(() => {
            			_window.location = options[1].uri
          			}, 5000)
              return
            }
            if (options[0].title === 'PARTNER_COURSE_LAUNCH') {
	            		window.location = options[0].uri
	              return
	          }

            if (options[0].title !== 'COURSE_FINISHED') {
              return this.$router.push({name: 'courseDashboard', params: {uuid: courseId, showLastActivity: true}})
            }
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        })
			},
			setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (title) {
        if ((title.indexOf('-') !== -1) && (title.indexOf('-') < 7)) {
          let splitted = title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return title.substring(0, 7)
      }
		},
    computed: {
      ...mapState({
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData,
        'institution': state => state.dashboard.institution,
        'userObj': state => state.login.userObj
      })
    }
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
  }

  .thumbnail_container .thumbnail {
  	width: 75px;
    height: 50px;
    border-radius: 8px;
    text-align: center;
  }

  .thumbnail_container .thumbnail .txt {
  	line-height: 50px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramCourseLearn.vue